import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';
import { trackQuickLinkClick } from '../../utils/tracking';
import { IQuickLink } from '../../../../../types/quickLinks';

interface IQuickLinkProps {
  link: IQuickLink;
}

export const QuickLink = ({ link }: IQuickLinkProps) => {
  const handleClick = React.useCallback(() => {
    trackQuickLinkClick(link.url, link.title);
  }, [link.url, link.title]);

  return (
    <a
      className={style['link']}
      data-testid="quick-links-item"
      href={link.url}
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
    >
      <UIText2 color="text-primary-default" as="span" display="inline-block">
        {link.title}
      </UIText2>
      <span className={style['counter']}>
        <UIText2 color="current_color" as="span" display="inline-block">
          {link.counter}
        </UIText2>
      </span>
    </a>
  );
};
